export enum AppointmentType {
    PHONE = 'appointment_type_phone',
    FACE_TO_FACE = 'appointment_type_face_to_face'
}
